<template>
  <div class="introductionPage">
    <div class="bannerBox"></div>
    <div class="jYmanagement">
      <div class="box">
        <ul style="margin-bottom:56px;" class="tabBox">
          <li v-for="(item,index) in tabList" :key="index" :class="activeIndex==index?'specialLi':''" @click="tabChange(index)">{{item}}</li>
        </ul>
        <div class="tabContent">
          <el-carousel ref='carousel' :initial-index="0" indicator-position="none" :autoplay="false" arrow="never">
            <el-carousel-item v-for="(item,index) in tabContentList" :key="index">
              <div class="tabContentItem">
                <div :class="index==1?'itemLeftSpecial':''" class="itemLeft">
                  <img :src="item.describe" alt="">
                </div>
                <div :class="index==1?'itemRightSpecial':''" class="itemRight">
                  <div v-for="(imgItem,imgIndex) in item.contentImg" :key="imgIndex" :class="contentIndex==imgIndex?'specialRightImg':''" class="rightImgBox">
                    <img class="rightImg" :src="imgItem.img" alt="">
                    <div v-if="index!=1" class="tipBanner">
                      <div class="tipBannerLeft">
                        <span v-if="imgItem.contentTitle" class="Title">{{imgItem.contentTitle}}</span>
                        <span v-if="imgItem.tip" class="tip">{{imgItem.tip}}</span>
                      </div>
                      <div v-if="item.contentImg.length>1" class="tipBannerRight">
                        <img @click="nextPage('left',item)" :class="contentIndex==0?'opcityClass':''" class="nextPageLeft" src="https://htmlqiniu.jihex.com/nextThrowPage.png" alt="">
                        <img @click="nextPage('right',item)" :class="contentIndex==item.contentImg.length-1?'opcityClass':''" class="nextPageRight" src="https://htmlqiniu.jihex.com/nextThrowPage.png" alt="">
                      </div>
                    </div>
                  </div>
                  <div :class="index==1?'specialCircleBox':''" class="circleBox">
                    <div v-for="(item,index) in tabList" :key="index" :class="activeIndex==index?'specialCircleItem':''" class="circleItem"></div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="qudaoBox"></div>
    <div class="wechatBox"></div>
    <div class="useBox"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      moduleList:[{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD1@2x.png'
      },{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD2@2x.png'
      },{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD3@2x.png'
      },{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD4@2x.png'
      },{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD5@2x.png'
      },{
        img:'https://html.qiniu.jihelife.com/website/%E5%8A%9F%E8%83%BD6-%E6%95%AC%E8%AF%B7%E6%9C%9F%E5%BE%85@2x.png'
      }],
      activeIndex:0,
      tabList:['多业态管理','多终端操作','营销管理','财务管理','个性化定制'],
      contentIndex:0,
      tabContentList:[{
        title:'多业态管理',
        describe:'https://htmlqiniu.jihex.com/newWebsiteImg.png',
        contentImg:[{
          img:'https://htmlqiniu.jihex.com/newWebsiteImg3.png',
          contentTitle:'商品管理',
          tip:'( 实物、在线预约套餐、虚拟、本地生活、旅游线路)'
        },{
          img:'https://htmlqiniu.jihex.com/manage_pic2.png',
          contentTitle:'日历房管理',
          tip:'',
        }],
      },{
        title:'多终端操作',
        describe:'https://htmlqiniu.jihex.com/two_text.png',
        contentImg:[{
          img:'https://htmlqiniu.jihex.com/newWebsiteImg4.png',
          contentTitle:'',
          tip:''
        }],
      },{
        title:'营销管理',
        describe:'https://htmlqiniu.jihex.com/three_text.png',
        contentImg:[{
          img:'https://htmlqiniu.jihex.com/three_pic1.png',
          contentTitle:'渠道直连',
          tip:''
        },{
          img:'https://htmlqiniu.jihex.com/three_pic2.png',
          contentTitle:'电子卡券',
          tip:'',
        },{
          img:'https://htmlqiniu.jihex.com/three_pic3.png',
          contentTitle:'营销工具',
          tip:'(积分抽奖、直播抽奖、一起卖卖爆)',
        }],
      },{
        title:'财务管理',
        describe:'https://htmlqiniu.jihex.com/four_text.png',
        contentImg:[{
          img:'https://htmlqiniu.jihex.com/newWebsiteImg2.png',
          contentTitle:'平安银行资金见证服务',
          tip:''
        },{
          img:'https://htmlqiniu.jihex.com/four_pic2.png',
          contentTitle:'我的账户',
          tip:'(在线化系统分账)',
        },{
          img:'https://htmlqiniu.jihex.com/four_pic3.png',
          contentTitle:'发票管理',
          tip:'',
        }],
      },{
        title:'个性化定制',
        describe:'https://htmlqiniu.jihex.com/five_text.png',
        contentImg:[{
          img:'https://htmlqiniu.jihex.com/five_pic.png',
          contentTitle:'店铺装修',
          tip:'(客户案例)'
        },],
      }]
    }
  },
  beforeCreate () {
    document.title = this.$route.meta.title
  },
  methods: {
    tabChange(index) {
      console.log(index)
      this.contentIndex =0
      this.activeIndex = index
      this.$refs.carousel.setActiveItem(this.activeIndex)
    },
    nextPage(type,item) {
      if(type=='left') {
        if(this.contentIndex==0) return;
        this.contentIndex = this.contentIndex - 1
      }else if(type=='right') {
        if(this.contentIndex==item.contentImg.length-1) return
        this.contentIndex = this.contentIndex + 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bannerBox {
  width: 100%;
  min-width: 1200px;
  height: 420px;
  background: url(https://htmlqiniu.jihex.com/productPageBanner.jpg);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.jYmanagement {
  width: 100%;
  min-width: 1200px;
  height: 836px;
  background: url(https://htmlqiniu.jihex.com/mananageTitle.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
  .box {
      width: 1200px;
      padding: 0px 10px;
      box-sizing: border-box;
      margin: 0 auto;
      ul,li {
        list-style: none;
        margin: 0px;
        padding: 0px;
      }
      .tabBox {
        width: 1200px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 190px;
        box-sizing: border-box;
        li {
          height: 32px;
          background: #FFFFFF;
          box-shadow: 0px 3px 16px 0px rgba(42, 54, 65, 0.08);
          border-radius: 16px;
          padding: 0px 20px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #606266;
          margin-right: 16px;
          &:hover {
            cursor: pointer;
          }
        }
        .specialLi {
          color: #FFFFFF;
          font-weight: bold;
          background: linear-gradient(90deg, #FF8D7E 0%, #F67365 100%);
          box-shadow: 0px 3px 16px 0px rgba(253, 125, 111, 0.24);
        }
        :last-child {
          margin-right: 0px;
        }
      }
      .tabContent {
        .tabContentItem {
          display: flex;
          justify-content: space-between;
          height: 508px;
          // margin-top: 56px;
          .itemLeft {
            width: 428px;
            img {
              width: 428px;
              height: 500px;
              display: block;
            }
          }
          .itemLeftSpecial {
            width: 240px;
            img {
              width: 240px;
              height: 500px;
              display: block;
            }
          }
          .itemRight {
            width: 728px;
            height: 500px;
            position: relative;
            .rightImgBox {
              width: 728px;
              height: 460px;
              opacity: 0;
              border-radius: 10px;
              box-shadow: 0px 0px 40px 0px rgba(42, 54, 65, 0.04);
              position: absolute;
            }
            .rightImg {
              width: 728px;
              height: 460px;
              border-radius: 10px;
            }
            .specialRightImg {
              opacity: 1;
              // display: block;
              transition:all 0.5s linear;
            }
            .tipBanner {
              width: 728px;
              height: 48px;
              background: url(https://htmlqiniu.jihex.com/pictureText.png) no-repeat 0/100%;
              position: absolute;
              left: 0px;
              bottom: 0px;
              border-radius: 0px 0px 10px 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .tipBannerLeft {
                margin-left: 24px;
                .Title {
                  font-weight: 600;
                  color: #FFFFFF;
                  font-size: 14px;
                }
                .tip {
                  color: #FFFFFF;
                  font-size: 12px;
                  margin-left: 8px;
                }
              }
              .tipBannerRight {
                width: 80px;
                height: 48px;
                margin-right: 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                img {
                  width: 48px;
                  height: 48px;
                  display: block;
                  &:hover {
                    cursor: pointer;
                  }
                }
                .nextPageLeft {
                  transform: rotateY(180deg);
                }
                .opcityClass {
                  opacity: 0.4;
                }
              }
            }
            .circleBox {
              display: flex;
              align-items: center;
              position: absolute;
              left: 94px;
              bottom: -8px;
              .circleItem {
                width: 8px;
                height: 8px;
                background: #FFD7D2;
                border-radius: 50%;
                margin-right: 12px;
              }
              :last-child {
                margin-right: 0px;
              }
              .specialCircleItem {
                background: #FD7D6F;
              }
            }
          }
          .itemRightSpecial {
            width: 916px;
            height: 500px;
            box-shadow:none;
            .rightImgBox {
              width: 916px;
              height: 500px;  
              box-shadow:none;  
            }
            .rightImg {
              width: 916px;
              height: 500px;
            }
            .specialCircleBox {
              left: 260px;
            }

          }
        }
      }
  }
}
.qudaoBox {
  width: 100%;
  min-width: 1200px;
  height: 800px;
  background: url(https://htmlqiniu.jihex.com/newWebsiteImg5.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
} 
.wechatBox { 
  width: 100%;
  min-width: 1200px;
  height: 635px;
  background: url(https://htmlqiniu.jihex.com/%E5%AE%A2%E6%9C%8D%E5%8C%BA%E5%9D%972.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
.useBox {
  width: 100%;
  min-width: 1200px;
  height: 850px;
  background: url(https://htmlqiniu.jihex.com/%E4%BB%96%E4%BB%AC%E9%83%BD%E5%9C%A8%E7%94%A8%E5%A4%AA%E7%9B%AE2.png);
  background-repeat: no-repeat;
  background-position:center center;
  background-size: cover;
}
</style>
<style>
.introductionPage .el-carousel__container {
  height: 508px;
}
</style>


// WEBPACK FOOTER //
// src/view/introduction.vue